'use strict';
const MLDO_CONFIG = require('./config');
window.MLDO_CONFIG = Object.freeze(MLDO_CONFIG);
